import PauseMonitoringBanner from './PauseMonitoringBanner';

export default PauseMonitoringBanner;
